import "./ProductSwipper.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { Pagination, Navigation } from "swiper/modules";
import { MdOutlineCamera } from "react-icons/md"

import { useNavigate } from "react-router-dom";

const ProductSwipper = ({ slides, productType }) => {
  const navigate = useNavigate();

  return (
    <Swiper
      slidesPerView={1}
      modules={[Pagination, Navigation]}
      navigation
      pagination={{ type: "progressbar", clickable: true }}
      style={{ padding: "0 3% 3% 3%;", borderRadius: "40px" }}
      spaceBetween={30}
    >
      {slides.map((slide) => (
        <SwiperSlide key={slide.id}>
          <div
            className="galaxy-container"
            onClick={() => navigate(slide.path)}
            style={{ cursor: "pointer" }}
          >
            <h2 className="galaxy-heading">{slide.title}</h2>
            {productType.toLowerCase() === "zfold" && (<p>{slide?.priceStarts}</p>)}
            <p className="galaxy-subheading">{slide.subtitle}</p>

            <div className="single-image-wrapper" style={{ margin: 0 }}>
              {slide.id === 2 && productType.toLowerCase() === "galaxya" && (
                <div class="hero-awesome">
                  <h1 class="awesome">
                    <span class="first-letter">A</span>wesome
                  </h1>
                </div>
              )}
              <img
                className="promo-image"
                // style={{transform: slide.id === 4  ? "translateY(2rem)" : "translateY(0)"}}
                src={slide.image}
                alt={slide.title}
              />
              {slide.id === 2 && productType.toLowerCase() === "galaxya" && (
                <>
                  <div class="hero-Intellig">
                    <h1 class="intelligence">
                      <span class="half">Intellig</span>
                      <span class="highlight-green">ence</span>
                    </h1>
                  </div>
                </>
              )}
            </div>
            {productType.toLowerCase() !== "zfold" && (
              <div className="galaxy-footer">{slide.footer}</div>
            )}
            {productType.toLowerCase() === "zfold" && (
              <div className="galaxy-footer d-flex gap-3 align-items-center justify-content-center">
                {slide.id !==3 && <MdOutlineCamera/>}<p>{slide.description}</p>
              </div>
            )}
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ProductSwipper;
